module.exports = __webpack_public_path__ + "media/images/riders/REBECCA_MCONNELL-1aae4496a3c905b10b658adb82f43fed.png";